import React from 'react';
import '../styles/Speakers-2024.css';

const Sponsors = () => {
  return (
    <section className="sponsors">
      <p className="copyright">© {new Date().getFullYear()} TED Conferences, LLC. All rights reserved.</p>
    </section>
  );
};

export default Sponsors;